import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CmModal from "../Controls/CmModal";
import { Form, FormInput, FormTextArea, FormSelect, FormActions } from "../Controls/Form";
import API from "../../API";
import { toast } from "react-toastify";

const categories = [
  { Key: "Feedback", Value: 1 },
  { Key: "Bug", Value: 2 },
];

/** Form body; receives `onClose` from CmModal (animated requestClose). */
function FeedbackFormBody({ onClose }) {
  const [form, setForm] = useState({
    category: 1,
    subject: "",
    message: "",
  });

  const onChangeCategory = (newValue) => {
    const value = Number(newValue?.value ?? newValue?.Value ?? newValue);
    setForm({ ...form, category: value });
  };

  async function onDoneAsync() {
    const subject = (form.subject || "").trim();
    const message = (form.message || "").trim();
    if (!subject || !message) {
      toast.error("Subject and message are required");
      return;
    }
    try {
      const resp = await API.postAsync("/Feedback", {
        Category: form.category,
        Subject: subject,
        Message: message,
        PagePath: window.location.pathname,
      });
      if (resp && resp.ok) {
        toast.success("Thanks — your feedback was submitted.");
        setForm({ category: 1, subject: "", message: "" });
        onClose?.();
      } else {
        toast.error(resp?.message || "Failed to submit feedback");
      }
    } catch (err) {
      toast.error("Error submitting feedback");
      console.error(err);
    }
  }

  return (
    <>
      <p className="byline">
        Tell us what is working or what broke. Your submission is stored for the team — we do not log
        message contents in the browser console beyond a generic error.
      </p>
      <Form object={form} onUpdate={setForm}>
        <FormSelect
          label="Type"
          field="category"
          valueProp="Value"
          labelProp="Key"
          options={categories}
          onChange={onChangeCategory}
        />
        <FormInput field="subject" label="Subject" required />
        <FormTextArea field="message" label="Details" required />
        <FormActions
          onSubmitAsync={onDoneAsync}
          onCancelAsync={async () => {
            onClose?.();
          }}
          doneLabel="Submit"
        />
      </Form>
    </>
  );
}

export default function FeedbackForm() {
  const navigate = useNavigate();

  return (
    <CmModal
      open
      bare
      onClose={() => navigate("/account")}
      title="Send feedback or report a bug"
      size="form"
      testId="feedback-form"
    >
      <FeedbackFormBody />
    </CmModal>
  );
}
